import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["facebookSection", "instagramSection", "tiktokSection"]

  togglePlatform(event) {
    const platform = event.target.value
    // Instagram: the Facebook Page comes from the Instagram account on save,
    // so the hidden Page picker is not sent.
    this.facebookSectionTarget
      .querySelectorAll("input[name='autoboost[fb_page_id]']")
      .forEach((input) => { input.disabled = platform === "instagram" })
    if (platform === "facebook") {
      this.facebookSectionTarget.classList.remove("hidden")
      this.instagramSectionTarget.classList.add("hidden")
      if (this.hasTiktokSectionTarget) this.tiktokSectionTarget.classList.add("hidden")
    } else if (platform === "instagram") {
      this.facebookSectionTarget.classList.add("hidden")
      this.instagramSectionTarget.classList.remove("hidden")
      if (this.hasTiktokSectionTarget) this.tiktokSectionTarget.classList.add("hidden")
    } else {
      this.facebookSectionTarget.classList.add("hidden")
      this.instagramSectionTarget.classList.add("hidden")
      if (this.hasTiktokSectionTarget) this.tiktokSectionTarget.classList.remove("hidden")
    }
  }
}
